import {
  createContext,
  type FunctionComponent,
  type ReactNode,
  useContext,
  useMemo,
} from 'react';
import { assert } from 'ts-essentials';
import scriptures from './scriptures.json';

export type ScripturePassage = {
  reference: string;
  text: string;
};

export type ScriptureService = {
  getPassage: () => ScripturePassage;
};

const defaultScriptureService: ScriptureService = {
  getPassage: () => {
    const scripture =
      scriptures.passages[
        Math.floor(Math.random() * scriptures.passages.length)
      ];
    assert(scripture);
    return scripture;
  },
};

const ScriptureContext = createContext<ScriptureService>(
  defaultScriptureService,
);

export type ScriptureProviderProps = {
  readonly children?: ReactNode;
  readonly scriptureService: ScriptureService;
};

export const ScriptureProvider: FunctionComponent<ScriptureProviderProps> = ({
  children,
  scriptureService,
}) => {
  return (
    <ScriptureContext.Provider value={scriptureService}>
      {children}
    </ScriptureContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- Not refreshed frequently
export const useScripture = (): ScripturePassage => {
  const scriptureService = useContext(ScriptureContext);
  const passage = useMemo(
    () => scriptureService.getPassage(),
    [scriptureService],
  );
  return passage;
};
